'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flexWrap', 'wrap', 'wrap');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/flex-wrap.js
// module id = 4330
// module chunks = 168707334958949